export const CURRENCY_CODE = 'PHP';
